/** Type def for questions(Event Questionnaire/Feedback) */

export enum QUESTION_TYPE {
  LONG = 'long',
  RADIO = 'radio',
  CHECK = 'check',
  LINEAR_SCALE = 'scale',
  NPS = 'nps',
  SATISFACTION = 'satisfaction',
  CONNECTION = 'connection',
  RETENTION = 'retention'
}

export const QUESTION_TYPE_LABELS = {
  [QUESTION_TYPE.LONG]: 'Long answer',
  [QUESTION_TYPE.RADIO]: 'Single choice',
  [QUESTION_TYPE.CHECK]: 'Multiple choice',
  [QUESTION_TYPE.LINEAR_SCALE]: 'Linear scale',
  [QUESTION_TYPE.NPS]: 'Net Promoter Score®',
  [QUESTION_TYPE.SATISFACTION]: 'Satisfaction score',
  [QUESTION_TYPE.CONNECTION]: 'Connection score',
  [QUESTION_TYPE.RETENTION]: 'Retention score'
};

export interface Properties {
  scaleMinValue?: number;
  scaleMaxValue?: number;
  scaleMinLabel?: string;
  scaleMaxLabel?: string;
}

export interface Question {
  id?: number;
  label: string;
  type: QUESTION_TYPE;
  isRequired: boolean;
  isDeleted?: boolean;
  sort?: number;
  options?: string[];
  shownBefore?: boolean;
  fromTemplate?: boolean;
  hasOtherOption?: boolean;
  isAnswered?: boolean;
  responses?: string[];
  properties?: Properties;
}

export interface EventQuestion extends Question {
  id: number;
  eventId: number;
}

export interface ContentQuestion extends Question {
  id: number;
  contentId: number;
}

// Generic question type used in event query responses
export interface GenericEventQueryQuestion {
  id: number;
  label: string;
  type: QUESTION_TYPE;
  isDeleted: boolean;
}
